module.exports = __webpack_public_path__ + "img/aboutUs.0e2a75bf.png";